import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Chấm công (Checkin.tsx). Mã nghiệp vụ và dữ liệu mẫu không dịch.
addMessages('vi', {
  'ci.today': 'Hôm nay',
  'ci.shiftTitle': 'Ca theo lịch công ty',
  'ci.tin': 'Giờ vào',
  'ci.late': 'trễ so với giờ vào ca',
  'ci.onTime': 'đúng giờ · khớp mặt 0,36',
  'ci.notYet': 'chưa chấm',
  'ci.tout': 'Giờ ra',
  'ci.worked': 'giờ làm 8,9 giờ',
  'ci.leaveHint': 'chấm khi rời văn phòng',
  'ci.fieldPill': 'Hiện trường · ghi lý do',
  'ci.officePill': 'Văn phòng · geofence {r} m',
  'ci.enrolled': 'Đã đăng ký khuôn mặt',
  'ci.notEnrolled': 'Chưa đăng ký khuôn mặt',
  'ci.noLoc': 'Chưa có vị trí',
  'ci.geoOff': 'Bật quyền vị trí để chấm công',
  'ci.geoField': 'Nhóm hiện trường · không giới hạn vị trí · cần ghi lý do',
  'ci.geoOffice': 'VP Cộng Hòa {d} m · ≤ {r} m · ±12 m',
  'ci.gotLoc': 'Đã lấy vị trí · sai số ±12 m',
  'ci.recIn': 'Đã ghi giờ vào {h}',
  'ci.recOut': 'Đã ghi giờ ra {h}',
  'ci.needLoc': 'Chưa có vị trí — bật quyền vị trí rồi thử lại',
  'ci.viaPk': ' · passkey',
  'ci.allDoneToast': 'Hôm nay đã chấm đủ',
  'ci.needConsent': 'Cần đồng ý lưu vector khuôn mặt trước',
  'ci.enrolledToast': 'Đã đăng ký khuôn mặt · 5 mẫu · mẫu đã khoá',
  'ci.waitGps': 'Chờ vị trí GPS…',
  'ci.needEnroll': 'Cần đăng ký khuôn mặt trước',
  'ci.gReady': 'Đưa mặt vào khung',
  'ci.gScan': 'Giữ yên… 72%',
  'ci.gOk': 'Khớp khuôn mặt · 0,36',
  'ci.gFail': 'Chưa nhận ra sau 14 giây · thử nơi đủ sáng',
  'ci.bReady': 'Bắt đầu quét',
  'ci.bScan': 'Đang quét…',
  'ci.bOk': 'Đã ghi',
  'ci.bFail': 'Quét lại',
  'ci.cancelScan': 'Huỷ quét, quay lại',
  'ci.clockIn': 'Chấm công vào',
  'ci.clockOut': 'Chấm công ra',
  'ci.tipsAria': 'Mẹo quét khuôn mặt',
  'ci.offTitle': 'Chấm công chưa bật',
  'ci.offDesc': 'Liên hệ HC–NS.',
  'ci.camAria': 'Khung camera',
  'ci.tip1': 'Ngang tầm mắt',
  'ci.tip2': 'Nhìn thẳng',
  'ci.tip3': 'Đủ sáng',
  'ci.tip4': 'Bỏ khẩu trang / kính râm',
  'ci.reasonLb': 'Lý do chấm công ngoài văn phòng',
  'ci.reasonPh': 'VD: Gặp khách RUITONGVN-SC tại Bình Dương',
  'ci.usePk': 'Dùng passkey thay khuôn mặt',
  'ci.tipsTitle': 'Mẹo quét nhanh',
  'ci.gotIt': 'Đã hiểu',
  'ci.l1': 'Cầm máy ngang tầm mắt, mặt nằm gọn trong khung.',
  'ci.l2': 'Nhìn thẳng, giữ yên khoảng 2 giây.',
  'ci.l3': 'Đứng nơi đủ sáng, không ngược sáng.',
  'ci.l4': 'Bỏ khẩu trang, kính râm, mũ che trán.',
  'ci.l5': 'Máy chậm có thể mất đến 14 giây; nếu không nhận ra, dùng passkey.',
  'ci.doneIn': 'Đã chấm công vào {h}',
  'ci.doneOut': 'Đã chấm công ra {h}',
  'ci.descField': 'Nhóm hiện trường · lý do đã ghi',
  'ci.descOffice': 'Trong bán kính văn phòng',
  'ci.finish': 'Xong',
  'ci.rDate': 'Ngày',
  'ci.rLoc': 'Vị trí',
  'ci.rDist': 'Khoảng cách',
  'ci.rNA': 'không áp dụng',
  'ci.rDistV': '{d} m tới VP HANA',
  'ci.rMatch': 'Khớp mặt',
  'ci.rSrc': 'Nguồn',
  'ci.rReason': 'Lý do',
  'ci.backCi': 'Quay lại Chấm công',
  'ci.verifyTitle': 'Xác thực chấm công',
  'ci.method': 'Cách xác thực',
  'ci.face': 'Khuôn mặt',
  'ci.offAcct': 'Chấm công chưa bật cho tài khoản này.',
  'ci.enrolledOn': 'Đã đăng ký khuôn mặt · {d}',
  'ci.relockTitle': 'Muốn đăng ký lại (đổi kính, đổi kiểu tóc nhiều), nhờ HC–NS mở khoá ở Nhân sự › Chấm công ngày.',
  'ci.locked': 'Mẫu đã khoá',
  'ci.enrollAria': 'Khung đăng ký',
  'ci.samples': '{n}/5 mẫu',
  'ci.enDone': 'Hoàn tất · mẫu đã khoá',
  'ci.enTurn': 'Xoay nhẹ mặt sang trái / phải giữa các mẫu',
  'ci.enHint': 'Lấy 5 mẫu ở các góc khác nhau để khớp bền hơn',
  'ci.consent1': 'Tôi đồng ý HANA lưu',
  'ci.consentB': 'vector khuôn mặt',
  'ci.consent2': '(không lưu ảnh) chỉ để chấm công, theo quy định bảo vệ dữ liệu cá nhân. Rút lại đồng ý qua HC–NS.',
  'ci.enrolledBtn': 'Đã đăng ký',
  'ci.nextShot': 'Lấy mẫu tiếp ({n}/5)',
  'ci.startEnroll': 'Bắt đầu đăng ký',
  'ci.pkTitle': 'Chấm công bằng passkey',
  'ci.pkDesc': 'Dùng vân tay / Face ID của máy đã đăng ký. Vị trí GPS vẫn được ghi như khi quét khuôn mặt.',
  'ci.thisDevice': 'Máy này',
  'ci.pkOut': 'Chấm công ra bằng passkey',
  'ci.pkIn': 'Chấm công vào bằng passkey',
  'ci.pkRegToast': 'Đã đăng ký passkey cho máy này',
  'ci.pkReg': 'Đăng ký passkey trên máy này',
  'ci.backMee': 'Quay lại HANA Mee',
  'ci.title': 'Chấm công',
  'ci.dept': 'Phòng {d}',
  'ci.more': 'Thêm · Góp ý',
  'ci.feedback': 'Góp ý: dùng nút Hei / Ask HANA ở thanh dưới',
  'ci.offAcct2': 'Chấm công chưa bật cho tài khoản',
  'ci.offAcctDesc': 'Tài khoản thuộc nhóm không cần chấm công, hoặc HC–NS chưa gán điểm làm việc. Liên hệ HC–NS để bật.',
  'ci.locFail': 'Không lấy được vị trí',
  'ci.locFailDesc': 'Máy từ chối quyền vị trí. Bật Vị trí cho HANA Mee trong Cài đặt máy rồi thử lại.',
  'ci.retry': 'Thử lại',
  'ci.locAria': 'Vị trí',
  'ci.map': 'Bản đồ Vietmap',
  'ci.regps': 'Lấy lại vị trí',
  'ci.setSite': 'Đặt điểm làm việc tại đây',
  'ci.warnDesc': 'Đăng ký một lần (5 mẫu, khoảng 20 giây) trước khi chấm công. Chỉ lưu vector, không lưu ảnh.',
  'ci.enrollBtn': 'Đăng ký khuôn mặt',
  'ci.allDone': 'Đã chấm đủ vào / ra hôm nay',
  'ci.week': 'Tuần này',
  'ci.workDays': '{n} ngày công',
  'ci.flag': 'Gắn cờ',
  'ci.siteDesc': 'Chỉ Admin / HC–NS. Toạ độ lấy từ GPS hiện tại · 10.8013, 106.6412.',
  'ci.cancel': 'Huỷ',
  'ci.save': 'Lưu',
  'ci.siteSaved': 'Đã lưu điểm “{n}” · bán kính {r} m',
  'ci.siteName': 'Tên điểm',
  'ci.radiusTitle': 'Giờ vào ca lấy từ lịch làm việc công ty (HR › Giờ làm việc & lễ). Số phút cho phép trễ đặt ở Cài đặt › Chấm công.',
  'ci.radius': 'Bán kính (m)',
  'ci.rNoConsent': 'Chưa đồng ý ghi vị trí',
});
addMessages('en', {
  'ci.today': 'Today',
  'ci.shiftTitle': 'Shift per company schedule',
  'ci.tin': 'Check-in',
  'ci.late': 'late for shift start',
  'ci.onTime': 'on time · face match 0.36',
  'ci.notYet': 'not clocked yet',
  'ci.tout': 'Check-out',
  'ci.worked': '8.9 hours worked',
  'ci.leaveHint': 'clock out when leaving the office',
  'ci.fieldPill': 'Field · reason required',
  'ci.officePill': 'Office · geofence {r} m',
  'ci.enrolled': 'Face enrolled',
  'ci.notEnrolled': 'Face not enrolled',
  'ci.noLoc': 'No location yet',
  'ci.geoOff': 'Enable location permission to clock in',
  'ci.geoField': 'Field group · no location limit · reason required',
  'ci.geoOffice': 'Cong Hoa office {d} m · ≤ {r} m · ±12 m',
  'ci.gotLoc': 'Location acquired · accuracy ±12 m',
  'ci.recIn': 'Check-in recorded {h}',
  'ci.recOut': 'Check-out recorded {h}',
  'ci.needLoc': 'No location yet — enable location permission and retry',
  'ci.viaPk': ' · passkey',
  'ci.allDoneToast': 'Already clocked in and out today',
  'ci.needConsent': 'Consent to storing the face vector is required first',
  'ci.enrolledToast': 'Face enrolled · 5 samples · template locked',
  'ci.waitGps': 'Waiting for GPS…',
  'ci.needEnroll': 'Enroll your face first',
  'ci.gReady': 'Place your face in the frame',
  'ci.gScan': 'Hold still… 72%',
  'ci.gOk': 'Face matched · 0.36',
  'ci.gFail': 'Not recognised after 14 s · try better light',
  'ci.bReady': 'Start scan',
  'ci.bScan': 'Scanning…',
  'ci.bOk': 'Recorded',
  'ci.bFail': 'Scan again',
  'ci.cancelScan': 'Cancel scan, go back',
  'ci.clockIn': 'Clock in',
  'ci.clockOut': 'Clock out',
  'ci.tipsAria': 'Face scan tips',
  'ci.offTitle': 'Clock-in not enabled',
  'ci.offDesc': 'Contact HR.',
  'ci.camAria': 'Camera frame',
  'ci.tip1': 'Eye level',
  'ci.tip2': 'Look straight',
  'ci.tip3': 'Good light',
  'ci.tip4': 'No mask / sunglasses',
  'ci.reasonLb': 'Reason for clocking in outside the office',
  'ci.reasonPh': 'e.g. Meeting client RUITONGVN-SC in Binh Duong',
  'ci.usePk': 'Use passkey instead of face',
  'ci.tipsTitle': 'Quick scan tips',
  'ci.gotIt': 'Got it',
  'ci.l1': 'Hold the phone at eye level, face fully inside the frame.',
  'ci.l2': 'Look straight and hold still for about 2 seconds.',
  'ci.l3': 'Stand in good light, not backlit.',
  'ci.l4': 'Remove mask, sunglasses and any hat covering your forehead.',
  'ci.l5': 'A slow device can take up to 14 seconds; if not recognised, use a passkey.',
  'ci.doneIn': 'Clocked in at {h}',
  'ci.doneOut': 'Clocked out at {h}',
  'ci.descField': 'Field group · reason recorded',
  'ci.descOffice': 'Within office radius',
  'ci.finish': 'Done',
  'ci.rDate': 'Date',
  'ci.rLoc': 'Location',
  'ci.rDist': 'Distance',
  'ci.rNA': 'not applicable',
  'ci.rDistV': '{d} m to HANA office',
  'ci.rMatch': 'Face match',
  'ci.rSrc': 'Source',
  'ci.rReason': 'Reason',
  'ci.backCi': 'Back to Check-in',
  'ci.verifyTitle': 'Verify clock-in',
  'ci.method': 'Verification method',
  'ci.face': 'Face',
  'ci.offAcct': 'Clock-in is not enabled for this account.',
  'ci.enrolledOn': 'Face enrolled · {d}',
  'ci.relockTitle': 'To re-enroll (new glasses, big hairstyle change), ask HR to unlock it in HR › Daily attendance.',
  'ci.locked': 'Template locked',
  'ci.enrollAria': 'Enrollment frame',
  'ci.samples': '{n}/5 samples',
  'ci.enDone': 'Done · template locked',
  'ci.enTurn': 'Turn your face slightly left / right between samples',
  'ci.enHint': 'Take 5 samples from different angles for a more robust match',
  'ci.consent1': 'I agree HANA stores my',
  'ci.consentB': 'face vector',
  'ci.consent2': '(no photo is stored) only for clock-in, per personal-data protection rules. Withdraw consent via HR.',
  'ci.enrolledBtn': 'Enrolled',
  'ci.nextShot': 'Next sample ({n}/5)',
  'ci.startEnroll': 'Start enrollment',
  'ci.pkTitle': 'Clock in with passkey',
  'ci.pkDesc': 'Use the fingerprint / Face ID of the enrolled device. GPS location is still recorded as with face scan.',
  'ci.thisDevice': 'This device',
  'ci.pkOut': 'Clock out with passkey',
  'ci.pkIn': 'Clock in with passkey',
  'ci.pkRegToast': 'Passkey registered for this device',
  'ci.pkReg': 'Register a passkey on this device',
  'ci.backMee': 'Back to HANA Mee',
  'ci.title': 'Check-in',
  'ci.dept': 'Dept. {d}',
  'ci.more': 'More · Feedback',
  'ci.feedback': 'Feedback: use the Hei / Ask HANA button in the bottom bar',
  'ci.offAcct2': 'Clock-in not enabled for this account',
  'ci.offAcctDesc': 'The account belongs to a group that does not clock in, or HR has not assigned a work site. Contact HR to enable it.',
  'ci.locFail': 'Could not get location',
  'ci.locFailDesc': 'Location permission was denied. Enable Location for HANA Mee in device Settings and retry.',
  'ci.retry': 'Retry',
  'ci.locAria': 'Location',
  'ci.map': 'Vietmap map',
  'ci.regps': 'Refresh location',
  'ci.setSite': 'Set work site here',
  'ci.warnDesc': 'Enroll once (5 samples, about 20 seconds) before clocking in. Only the vector is stored, not photos.',
  'ci.enrollBtn': 'Enroll face',
  'ci.allDone': 'Clocked in and out for today',
  'ci.week': 'This week',
  'ci.workDays': '{n} work days',
  'ci.flag': 'Flagged',
  'ci.siteDesc': 'Admin / HR only. Coordinates from current GPS · 10.8013, 106.6412.',
  'ci.cancel': 'Cancel',
  'ci.save': 'Save',
  'ci.siteSaved': 'Saved site “{n}” · radius {r} m',
  'ci.siteName': 'Site name',
  'ci.radiusTitle': 'Shift start comes from the company work calendar (HR › Work hours & holidays). Grace minutes are set in Settings › Check-in.',
  'ci.radius': 'Radius (m)',
  'ci.rNoConsent': 'Location consent not given',
});
